var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.3333 0H10.6667C3.85778 0 0 3.85778 0 10.6667V29.3333C0 36.1244 3.84 40 10.6667 40H29.3333C36.1422 40 40 36.1244 40 29.3333V10.6667C40 3.85778 36.1422 0 29.3333 0Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6751 20.1708C14.4304 20.1708 15.0427 20.7831 15.0427 21.5384V27.0085C15.0427 27.7637 14.4304 28.376 13.6751 28.376C12.9199 28.376 12.3076 27.7637 12.3076 27.0085V21.5384C12.3076 20.7831 12.9199 20.1708 13.6751 20.1708Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.513 14.7011C21.2683 14.7011 21.8806 15.3133 21.8806 16.0686V27.0088C21.8806 27.7641 21.2683 28.3764 20.513 28.3764C19.7578 28.3764 19.1455 27.7641 19.1455 27.0088V16.0686C19.1455 15.3133 19.7578 14.7011 20.513 14.7011Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.35 9.23083C28.1052 9.23083 28.7175 9.8431 28.7175 10.5984V27.0087C28.7175 27.764 28.1052 28.3762 27.35 28.3762C26.5947 28.3762 25.9824 27.764 25.9824 27.0087V10.5984C25.9824 9.8431 26.5947 9.23083 27.35 9.23083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkImg);
export default __webpack_public_path__ + "static/media/networkImg.aeb1636a10edc1afc3dfda6319a67691.svg";
export { ForwardRef as ReactComponent };